import type { IconSvgObject } from './types';

const ChartBreakoutSquareIcon: IconSvgObject = [
  ["path", { d: "M16.0547 4V2.5M19.0547 4.99273L20.5547 3.5M20.0547 8H21.5", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M21.5001 12V19.5C21.5001 20.6046 20.6047 21.5 19.5001 21.5H4.50011C3.39554 21.5 2.50011 20.6046 2.50011 19.5V4.5C2.50011 3.39543 3.39554 2.5 4.50011 2.5H12.0557", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "1" }],
  ["path", { d: "M2.55469 15C11.0547 15 16.0547 8 16.0547 8M16.0547 11.5V8H12.5547", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "2" }]
];

export default ChartBreakoutSquareIcon;
